/* tslint:disable */
import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable()
export class LogUpdateService {

  constructor(private readonly swUpdate: SwUpdate) {

  }
  init(): void {
    this.swUpdate.available.subscribe(event => {
      console.dir('Available => ');
      console.dir('current version is', event.current);
      console.dir('available version is', event.available);
      console.dir(event);
    });
    this.swUpdate.activated.subscribe(event => {
      console.dir('Activated => ');
      console.dir('old version was', event.previous);
      console.dir('new version is', event.current);
      console.dir(event);
    });
  }
}
